import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "highlighted"];

/* eslint-disable react/no-array-index-key */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from '../index.module.scss';
var SYSTEM_PROPS = [];
var Suggestion = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      highlighted = _ref.highlighted,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement("li", _extends({}, rest, {
    ref: ref,
    className: cx((_cx = {}, _cx[styles.suggestionRoot] = true, _cx[styles.suggestionHighlighted] = highlighted, _cx))
  }), children);
});
Suggestion.displayName = 'Suggestion';
Suggestion.identifier = Suggestion.displayName; // used in docs website

Suggestion.clonableProps = SYSTEM_PROPS;
Suggestion.propTypes = {
  /* The suggestion to render */
  suggestion: PropTypes.oneOfType([PropTypes.array, // eslint-disable-line
  PropTypes.object, // eslint-disable-line
  PropTypes.string])
};
export default Suggestion;